<script>
	const Vue = require('vue');
	const page = require('page');
	const Util = require('utilities');
	const Store = require('kvstore');
	const userContext = require('core/userContext');
	const metadata = require('core/metadata');
	const messages = require('core/messages');
	const session = require('core/session');
	const model = require('model/model');
	const cookieStore = require('model/stores/cookieStore');
	const accountService = require('services/accountService');
	const campaignUtilities = require('utilities/campaignUtilities');
	const removeCampaignCookie = campaignUtilities.removeCampaignCookie;
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const TOKEN_EXPIRED = analyticsUtilities.events.TOKEN_EXPIRED;
	const pubsub = require('events/pubsub');
	const logger = require('utilities/logger');
	require('utilities/navigationTracker');
	require('utilities/breakpoints');

	const journeyUtilities = require('utilities/journeyUtilities');
	const initJourneys = journeyUtilities.initJourneys;

	const accountSettingsUtilities = require('utilities/accountSettingsUtilities');
	const accountUtilities = require('utilities/accountUtilities');

	const { CAMPAIGN_BANNERS } = accountSettingsUtilities;

	const { enableOfflineMode, disableOfflineMode } = require('utilities/offlineUtilities');

	const { assetUrl } = require('utilities/urlUtilities');
	const { setGCAddon } = require('utilities/googleClassroomUtilities');

	// for CAMPAIGN_BANNERS.remoteInPerson
	Vue.component('remote-in-person-campaign', require('components/notifications/remote-in-person-campaign.vue').default);
	Vue.component('please-review-school-campaign', require('components/notifications/please-review-school-campaign.vue').default);

	// All users even unauth'd
	// model.set('bannerNotification', CAMPAIGN_BANNERS.remote);

	model.change('userContext', function (uc) {
		if (uc) {
			// if (uc.legacy) {
			// 	model.set('bannerNotification', {
			// 		body: 'Starting February 11th, all Pinellas teachers and students can access ReadWorks through their Clever portals. Any data and information in this ReadWorks account will go away at the end of the 2018-19 school year. <a href="https://readworks.force.com/s/article/what-is-changing-for-pinellas-county-schools-in-readworks" target="_blank">Learn more.</a>'
			// 	});
			// } else
			if (uc.campaign && CAMPAIGN_BANNERS[uc.campaign]) {
				model.set('bannerNotification', CAMPAIGN_BANNERS[uc.campaign]);
			}

			if (uc.uid && !userContext.isStudent()) {
				initJourneys();
			}
			// else {
			// 	model.remove('bannerNotification');
			// }
		}
	});

	/**
	 * This and all app error return codes should be encapsulated
	 * in a js or json file obtained perhaps from the metadata.json
	 * object (version-sensitive!). - rk
	 *
	 * REACHED_STUDENT_LIMIT: number of students allowed in a class reached maximum
	 */
	var REACHED_STUDENT_LIMIT = 1059;

	var STUDENT_INACTIVITY_TIMEOUT = 1000 * 60 * 60; // 1 hour

	var TEACHER_INACTIVITY_TIMEOUT = 1000 * 60 * 60 * 3; // 3 hours

	/**
	 * SVGeezy
	 * https://github.com/benhowdle89/svgeezy
	 */
	var svgeezy = require('modules/jquery.svgeezy.js');

	var autoLogoutTimeout;

	var autoLogoutTriggered = false;

	var loginTime,
		loggedNoTokenExpiration = false;

	var startUpTime = Date.now();

	var sessionTimeoutId;

	function setSessionTimer() {
		if (typeof sessionTimeoutId !== 'undefined') {
			clearTimeout(sessionTimeoutId);
		}

		sessionTimeoutId = setTimeout(function () {
			session.initialize();
		}, session.SESSION_INACTIVITY_TIMEOUT);
	}

	setSessionTimer();

	const urlParams = new URLSearchParams(location.search);
	const addon = urlParams.get('addon');
	const googleToken = urlParams.get('token');
	const rwToken = cookieStore.get('rw-token');
	let teacherGoogleSignInError = false;

	setGCAddon();

	if (googleToken === 'access-denied' && location.pathname !== '/student-authentication') {
		teacherGoogleSignInError = true;
	} else if (addon && window.opener) {
		window.opener.postMessage(
			{
				name: 'google-addon-return',
				googleToken,
				rwToken,
				success: !!googleToken,
				urlParams: location.search
			},
			location.origin
		);
		cookieStore.remove('rw-token');
		window.close();
	} else if (rwToken) {
		accountUtilities.getFromToken(rwToken);
		cookieStore.remove('rw-token');
	} else if (addon) {
		// automated student GCA re-authentication
		page(`/student-authentication${location.search}`);
	}

	module.exports = {
		components: {
			'lessons-and-units-secondary-nav': require('components/nav/lessons-and-units-secondary-nav.vue').default,
			'video-modal': require('components/video-modal.vue').default,
			'vocabulary-image-modal': require('components/vocabulary-image-modal.vue').default,
			'share-buttons': require('components/share-buttons.vue').default,
			'google-classroom-import-modal': require('components/google-classroom-import-modal.vue').default,
			'journey-dialog': require('components/journey-dialog.vue').default,
			'notification-bar': require('components/nav/notification-bar.vue').default,
			'donation-parent-modal': require('components/donation-parent-modal.vue').default,
			'workspace-preview-modal': require('components/workspace-preview-modal.vue').default,
			'toggle-buttons': require('components/toggle-buttons.vue').default,
			'offline-mode-toggle': require('components/offline-mode-toggle.vue').default,
			'offline-assignment-submitted-modal': require('components/offline-assignment-submitted-modal.vue').default,
			'bifurcated-login-modal': require('components/bifurcated-login-modal.vue').default,
			'unauth-footer': require('components/nav/unauth-footer.vue').default,
			'awards-list': require('components/nav/awards-list.vue').default,
			'form-submitter': require('components/form-submitter.vue').default,
			'snap-to-top': require('components/snap-to-top.vue').default
		},
		modelData: ['whiteboardView', 'splitScreen', 'offlineAssignments', 'userContext', 'distractionFreeView', 'localGCAccessToken', 'gcAddon'],
		data: function () {
			let pinterestThumbnail = '/assets/dist/images/social-media-thumbnail.jpg';
			return {
				teacherMessageSubject: null,
				teacherMessageBody: null,
				studentMessageSubject: null,
				studentMessageBody: null,

				// used to control the tabs on the signup/in dialog
				currentRoute: {
					component: '',
					public: false,
					site: ''
				},
				titleOverride: null,
				gradeDefaults: {},
				routeContext: {},
				roleDefault: 0,
				metaData: {
					roles: []
				},
				signUpForm: {
					email: '',
					password: '',
					firstName: '',
					lastName: '',
					role: 0,
					grades: [],
					schoolIdName: '0'
				},
				resetPasswordForm: {
					email: ''
				},
				messageIndex: 0,
				messages: [],
				pinterestThumbnail,
				hideNav: false,
				staticLogo: false,
				studentInactivityTriggered: false
			};
		},
		computed: {
			numberOfOfflineAssignments() {
				let uid = this.userContext ? this.userContext.uid : null;
				let classCode = this.userContext ? this.userContext.classCode : null;
				let offlineAssignments = this.offlineAssignments || {};
				let number = 0;
				if (uid && offlineAssignments && offlineAssignments[uid]) {
					let assignments = Object.keys(offlineAssignments[uid]).filter(aid => {
						let a = offlineAssignments[uid][aid];
						return a && a.cc === classCode;
					});
					number = assignments.length;
				}
				return number;
			},
			showAwards() {
				const allowedRoutes = new Set(['home', 'teacher-guide']);

				return allowedRoutes.has(this.routeContext.route);
			},
			currentNav() {
				const currentRoute = this.currentRoute;
				const site = currentRoute.site;
				const noAuth = currentRoute.public;
				const currentComponent = currentRoute.component;
				const lessonAndUnit = ['route-lessons-and-units', 'route-drupal-harness', 'route-binder'].includes(currentComponent);

				if (site === 'teacher') {
					return lessonAndUnit ? 'lessons-and-units-nav' : 'teacher-nav';
				}

				if (site === 'student' || (site === 'both' && userContext.isStudent() && !noAuth)) {
					return 'student-nav';
				}

				if (!this.userContext && noAuth && site === 'both') {
					return 'unauth-nav';
				}

				return 'teacher-nav';
			}
		},
		mounted() {
			var self = this;

			self.$subscribe('modal-closed', function (id) {
				if (id === 'logged-out-automatically-modal' || id === 'token-timeout-modal') {
					const encodedRedirectUrl = self.getRedirectUrl();
					let href = `/?url=${encodedRedirectUrl}#login`;

					if (self.gcAddon) {
						const addonParams = new URLSearchParams(self.gcAddon);
						// automatically reauthenticate on timeout acknowledgement
						addonParams.set('reauth', true);
						href = `/classroom-addon?${addonParams.toString()}`;
					} else if (self.currentRoute.site === 'student' || self.studentInactivityTriggered) {
						href = `/student-authentication?url=${encodedRedirectUrl}`;
					}

					location.href = href;
				}
			});

			pubsub.subscribe('forgot-password', email => {
				this.resetPasswordForm.email = email;

				Util.closeModals();
				Util.openModal('#modal-forgot-password');
			});

			// This is done to make vueApp.$emit callable to CommonJS modules that aren't Vue components
			// The reason this is needed is to be able to emit messages, such as "go-home" (when a
			// 401 is received in HTTP indicating a stale x-auth) or "message"
			Store.set('$emit', function () {
				return pubsub.publish(...arguments);
			});
			Store.set('$broadcast', function () {
				return pubsub.publish(...arguments);
			});

			pubsub.subscribe('logged-in', () => {
				loginTime = new Date().getTime();

				this.resetLogoutTimer();

				return true;
			});

			pubsub.subscribe('logout', function () {
				// TODO: when we stop refreshing on logout add a cache.invalidateAllCaches() call (but ensure reget isn't invoked)

				let offline = model.get('offlineMode');

				pubsub.publish('before-log-out');

				var isStudent = (userContext && userContext.isStudent()) || self.currentRoute.site === 'student';

				var event = isStudent ? 'STUDENT_SIGNOUT' : 'TEACHER_SIGNOUT';
				const googleKey = isStudent ? 'username' : 'google';

				const gcAddon = model.get('gcAddon');
				let addonParams = new URLSearchParams(gcAddon);
				const currentUserContext = model.get('userContext');

				if (gcAddon && currentUserContext && currentUserContext[googleKey] === gcAddon.login_hint) {
					// automatically reauthenticate if signed out of account GCA provides
					addonParams.set('reauth', true);
				}

				fireEvent(event).finally(() => {
					// some components (e.g. student.vue) need to show dialogs/etc when logged out
					pubsub.publish('logged-out');

					removeCampaignCookie();

					userContext.reset();
					session.initialize();

					if (gcAddon) {
						location.href = `/classroom-addon?${addonParams.toString()}`;
					} else if (!isStudent || !offline) {
						location.href = isStudent ? '/student-authentication' : '/';
					} else {
						disableOfflineMode().then(() => {
							location.href = '/student-authentication';
						});
					}
				});

				return true;
			});

			self.teacherMessageSubject = messages.teacherTitle;
			self.teacherMessageBody = messages.teacherStatusMessage;
			self.studentMessageSubject = messages.studentTitle;
			self.studentMessageBody = messages.studentStatusMessage;

			self.signUpForm.gradeSelections = metadata.gradeSelections;

			// Install a popstate listener before page.start is invoked
			// This is to catch an issue with the interaction of the html5-history-api and
			// page.js. On IE (even 11) relative links and clicks to hash links do not work
			// correctly. This is compounded by the fact that, for hash links html5-history-api
			// does not include the hash. So /some/path#my-hash will go to routing as just
			// /some-path. This event listener kicks in before page.js' listener and adds
			// (or corrects) the hash where it's needed
			window.addEventListener('popstate', function (ev) {
				if (ev && ev.state && ev.state.path) {
					if (window.location.hash) {
						ev.state.path = ev.state.path.replace(/#.*$/, '');
						ev.state.path += window.location.hash;
					}
				}
			});
			// Start routing
			page.start({
				popstate: false
			});

			$(window).on('scroll', this.onUserInput.bind(this));

			// workaround to an apparent bug in page.js onpopstate. When an <a href="#"> is clicked
			// page.js onclick ignores the event, but onpopstate still fires. Since e.state is not
			// populated, page.js does a show with only pathname + hash (omitting querystring).
			// To fix this issue, we tell page.start above not to install the page.js popstate handler
			// we then use a modified one below which fixes the issue.
			var onpopstate = (function () {
				var loaded = false;
				if ('undefined' === typeof window) {
					return undefined;
				}
				if (document.readyState === 'complete') {
					loaded = true;
				} else {
					window.addEventListener('load', function () {
						setTimeout(function () {
							loaded = true;
						}, 0);
					});
				}
				return function (e) {
					if (loaded) {
						if (e.state) {
							var path = e.state.path;
							page.replace(path, e.state);
						} else {
							// original page.js line:
							// page.show(location.pathname + location.hash, undefined, undefined, false);
							// modified line to fix the issue:
							page.show(location.pathname + location.search + location.hash, undefined, undefined, false);
						}
					}
				};
			})();
			window.addEventListener('popstate', onpopstate, false);

			svgeezy({
				avoid: false,
				filetype: 'png'
			}).on();

			Util.initModals();

			pubsub.subscribe('message', function () {
				self.message.apply(self, arguments);
				return true;
			});
			pubsub.subscribe('message-error', function () {
				self.errorMessage.apply(self, arguments);
				return true;
			});
			pubsub.subscribe('message-success', function () {
				self.successMessage.apply(self, arguments);
				return true;
			});

			pubsub.subscribe('submit-succeeded', function (evData) {
				switch (evData.formName) {
					case 'signUpForm':
						pubsub.publish('message-success', 'Sign-up succeeded!');
						break;

					case 'resetPasswordForm':
						Util.closeModals();
						pubsub.publish('message-success', 'Password recovery email sent, check your email');
						break;
				}
				return true;
			});
			pubsub.subscribe('submit-failed', function (evData) {
				switch (evData.formName) {
					case 'signUpCredentials':
					/* fall through */
					case 'signInCredentials':
						self.submitMaybeStudentClassLimitExceeded(evData);
						break;
				}
				return true;
			});

			Vue.nextTick(() => {
				$(this.$el).show();

				model.set('whiteboardView', false);
				model.set('distractionFreeView', false);
			});

			if (teacherGoogleSignInError) {
				pubsub.publish('message-error', "We're sorry, if you do not allow ReadWorks permission, you will not be able to login with Google.");

				Util.openModal('#teacher-login-modal');
			}
			//Util.openModal('#downtime-modal');
		},
		methods: {
			closeModals: function () {
				Util.closeModals();
			},
			resetPassword: function (data) {
				return accountService.accountRecovery(data).catch(e => {
					if (e.code !== 1027) {
						throw e;
					}
				});
			},
			onUserInput: function () {
				this.resetLogoutTimer();

				setSessionTimer();
			},
			/**
			 * Clear any existing timeout and set a new one. The timeout used will
			 * but shortest of the following:
			 * - Token timeout (12 hours from the last sign-in)
			 * - 1 or 3 hours of inactivity (for student or teacher, respectively)
			 * - 0 if forceTokenExpiration is set in localStorage
			 */
			resetLogoutTimer: function () {
				if (!userContext.loggedIn() || autoLogoutTriggered) {
					return;
				}

				if (autoLogoutTimeout) {
					clearTimeout(autoLogoutTimeout);
					autoLogoutTimeout = null;
				}

				if (model.get('offlineMode')) {
					return;
				}

				var now = Date.now(),
					minTimeout,
					timeoutChoices = [],
					isStudent = false;

				// if logged in as student, add student timeout as a choice
				if (userContext.loggedIn()) {
					if (userContext.isStudent()) {
						timeoutChoices.push(STUDENT_INACTIVITY_TIMEOUT);
						isStudent = true;
					} else {
						timeoutChoices.push(TEACHER_INACTIVITY_TIMEOUT);
					}
				}

				if (model.get('forceTokenExpiration')) {
					logger.info('found forceTokenExpiration, will log out now');
					timeoutChoices.push(0);
				}

				var tokenExpiration = model.get('tokenExpiration');
				var tokenTimeout;

				// we only set a token timeout if we have marked the token expiration
				if (tokenExpiration) {
					tokenTimeout = tokenExpiration - now;
					timeoutChoices.push(tokenTimeout);
				} else {
					if (!loggedNoTokenExpiration) {
						logger.error('no token expiration found for', isStudent ? 'student' : 'teacher', 'guessing timeout');

						// keep track that we sent this message, we don't want to flood track.js with one
						// user's message if there's some weird failure
						loggedNoTokenExpiration = true;
					}

					model.set('tokenExpiration', now + TEACHER_INACTIVITY_TIMEOUT);
				}

				minTimeout = Math.min.apply(null, timeoutChoices);

				var isTokenTimeout = tokenTimeout && minTimeout === tokenTimeout;

				autoLogoutTimeout = setTimeout(() => {
					var drupalModal = this.$refs.drupalNameModal;
					autoLogoutTimeout = null;
					autoLogoutTriggered = true;

					if (model.get('offlineMode')) {
						return;
					}

					if (userContext && userContext.isStudent()) {
						this.studentInactivityTriggered = true;
					}

					userContext.reset();

					model.remove('forceTokenExpiration');

					if (isTokenTimeout) {
						logger.info('showing token timed out message, token expired at', tokenExpiration, 'time is now', Date.now());
						this.$refs.tokenTimeoutModal.show();

						fireEvent(TOKEN_EXPIRED, {
							duration: loginTime && (new Date().getTime() - loginTime) / 1000 // Amount of time, in seconds, that the user has been logged in for
						});
						if (Date.now() - startUpTime < 150000) {
							// if user is shown this modal within 2.5 minutes of opening the page, log it
							logger.info("It's only been", Date.now() - startUpTime, 'ms since the code started');
							logger.error('Possibly premature "sorry to be a bother"');
						}
					} else if (!drupalModal.$refs.modal.isVisible()) {
						// if drupal name form is visible
						// don't show log in modal
						this.$refs.loggedOutAutomaticallyModal.show();
					}
				}, minTimeout);
			},
			message: function (m, opts) {
				var id = '_' + this.messageIndex++;

				// apply default options where no other option specified
				var message = $.extend(
					true,
					{
						id: id,
						message: m,
						success: false,
						error: false,
						fixed: true,
						timeout: 4000
					},
					opts
				);

				this.messages.push(message);

				// automatically remove message after timeout
				// unless timeout is null or 0 (falsey)
				if (message.timeout) {
					let timeoutId = setTimeout(() => this.deleteMessage(message), message.timeout);
					message.timeoutId = timeoutId;
				}
			},
			deleteMessage: function (message, event) {
				let msgs = this.messages;
				let id = message.id;

				// If user clicked a link in the alert, don't remove
				if (event && event.target.tagName === 'A') {
					return;
				}

				if (msgs && msgs.length) {
					this.messages = msgs.filter(msg => msg.id !== id);

					// Message is removed, no need for timeout
					if (message.timeoutId) {
						clearTimeout(message.timeoutId);
					}
				}
			},
			// convenience method for messages with success:true
			successMessage: function (m, opts) {
				this.message(
					m,
					$.extend(true, {}, opts, {
						success: true
					})
				);
			},
			// convenience method for messages with error:true
			errorMessage: function (m, opts) {
				this.message(
					m,
					$.extend(true, {}, opts, {
						error: true
					})
				);
			},
			onRouteReady: function () {},
			submitMaybeStudentClassLimitExceeded: function (evData) {
				if (evData.res && typeof evData.res.body === 'object' && evData.res.body.code === REACHED_STUDENT_LIMIT) {
					pubsub.publish(
						'message-error',
						'There cannot be more than 100 students in one class. Please let your teacher know that you were unable to join because the class is at the limit.`'
					);
				}
			},
			onEnableOfflineModeClick() {
				enableOfflineMode().then(() => {
					page('/student');
					setTimeout(() => window.location.reload());
				});
			},
			assetUrl(url) {
				return assetUrl(url);
			},
			onSkipLinkClick() {
				this.$refs.pageContent.focus();
				this.$refs.pageContent.scrollIntoView(true);
			},
			getRedirectUrl() {
				const path = window.location.pathname;
				const hash = window.location.hash;
				const query = window.location.search;

				let url = path;
				if (query) url += query;
				if (hash) url += hash;

				return encodeURIComponent(url);
			}
		},
		watch: {
			localGCAccessToken(gcToken) {
				if (userContext.isTeacher()) {
					// setGCClassList(gcToken);
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'mixins/flexbox';

	#main-application {
		.skip-link {
			position: absolute;
			top: -3rem;
			left: 0;
			z-index: 5;

			&:focus {
				top: 0;
				transition-duration: 0.1s;
			}
		}

		.page {
			&:focus {
				outline: none;
			}
		}

		.bottom {
			.wrapper {
				.share-glyphs {
					position: relative;
				}
			}

			.bottom-fineprint {
				p {
					margin-top: 0.25rem;
				}

				li {
					margin-bottom: 0.5rem;
				}

				sup {
					position: static;
				}
			}
		}

		.route-home & {
			.unauth-nav .wrapper {
				width: 100%;
				padding: 0 1rem;
			}

			.bottom .wrapper {
				position: relative;
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		#main-application {
			.route-student-workspace & {
				position: fixed;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				@include flexbox();
				@include flex-direction(column);

				.student-nav {
					@include flex-basis(4rem);
				}

				.page {
					@include flex(1);
					@include flexbox();
					@include flex-direction(column);
					min-height: 0px;
				}

				.bottom {
					display: none;
				}
			}

			.bottom-fineprint {
				display: flex;
				justify-content: space-between;

				p {
					margin-bottom: 0;
				}

				.share-glyphs {
					flex: 0 0 9rem;
					margin: 0 0.8rem;
				}
			}
		}
	}
</style>
<template>
	<div
		v-scroll-target-helper
		v-on:click="onUserInput"
		v-on:mousemove="onUserInput"
		v-on:keypress="onUserInput"
		v-on:touchstart="onUserInput"
		id="main-application"
		:class="{
			'whiteboard-view': whiteboardView,
			'distraction-free': distractionFreeView,
			'split-screen': splitScreen
		}">
		<a
			href="javascript:void(0)"
			class="skip-link button"
			:class="{ '-outline': currentNav !== 'unauth-nav' }"
			@click="onSkipLinkClick">
			Skip to main content
		</a>
		<ul
			v-if="messages.length > 0"
			class="list-unstyled"
			aria-label="ReadWorks system messages">
			<li
				v-for="m in messages"
				:key="m.id"
				class="alert"
				:class="{
					'-success': m.success,
					'-fixed': m.fixed,
					'-error': m.error
				}"
				role="alert">
				<span
					v-if="m.hasSafeHTML"
					v-html="m.message"></span>
				<span v-else>{{ m.message }}</span>
				<button
					class="button -link alert-close"
					aria-label="Delete message"
					@click="deleteMessage(m, $event)">
					&times;
				</button>
			</li>
		</ul>
		<header
			v-if="!gcAddon"
			class="print-hidden"
			:class="[
				{
					top: currentNav !== 'unauth-nav'
				},
				currentNav
			]">
			<div class="wrapper">
				<component
					:route-context="routeContext"
					:account-name="userContext && userContext.firstName"
					:route-component="currentRoute.component"
					:hide-nav="hideNav"
					:static-logo="staticLogo"
					:is="currentNav"></component>
			</div>
			<lessons-and-units-secondary-nav v-if="currentNav === 'lessons-and-units-nav'"> </lessons-and-units-secondary-nav>
			<notification-bar :route-context="routeContext"> </notification-bar>
		</header>
		<!-- end .top -->
		<div
			ref="pageContent"
			class="page"
			tabindex="-1"
			aria-label="Main content">
			<component
				wait-for="data-ready"
				:route-context="routeContext"
				:on-ready="onRouteReady"
				:title-override="titleOverride"
				:is="currentRoute.component"></component>
		</div>
		<!-- end .page -->
		<unauth-footer v-if="!gcAddon && currentNav === 'unauth-nav'"></unauth-footer>
		<footer
			v-else-if="!gcAddon"
			class="bottom print-hidden">
			<div class="wrapper">
				<div class="bottom-fineprint">
					<div>
						<ul v-if="routeContext.site == 'teacher'">
							<li>
								<a
									href="/terms"
									target="_blank"
									>Terms</a
								>
							</li>
							<li>
								<a
									href="/privacy"
									target="_blank"
									>Privacy</a
								>
							</li>
							<li>
								<outbound-link
									href="https://about.readworks.org/licensing.html"
									target="_blank"
									data-outbound-link="FOOTER_LICENSING">
									Licensing
								</outbound-link>
							</li>
							<li>
								<outbound-link
									href="https://about.readworks.org/our-partners.html"
									target="_blank"
									data-outbound-link="FOOTER_PARTNERS">
									Partners
								</outbound-link>
							</li>
							<li>
								<outbound-link
									href="https://about.readworks.org/"
									target="_blank"
									data-outbound-link="FOOTER_ABOUT">
									About Us
								</outbound-link>
							</li>
							<li>
								<outbound-link
									href="https://about.readworks.org/blog"
									target="_blank"
									data-outbound-link="FOOTER_BLOG">
									Blog
								</outbound-link>
							</li>
							<li>
								<outbound-link
									href="https://about.readworks.org/dei.html"
									target="_blank"
									data-outbound-link="FOOTER_DEI">
									DEI Commitment
								</outbound-link>
							</li>
							<li>
								<outbound-link
									href="https://about.readworks.org/corevalues.html"
									target="_blank"
									data-outbound-link="FOOTER_VALUES">
									Core Values
								</outbound-link>
							</li>
							<li>
								<outbound-link
									href="https://about.readworks.org/accessibility-statement.html"
									target="_blank"
									data-outbound-link="FOOTER_A11Y_STATEMENT">
									Accessibility Statement
								</outbound-link>
							</li>
							<li>
								<outbound-link
									href="https://about.readworks.org/donate.html"
									target="_blank"
									data-outbound-link="FOOTER_DONATE">
									Donate
								</outbound-link>
							</li>
						</ul>
						<p>
							<small>ReadWorks<sup>&reg;</sup> is a Registered Trademark | &copy; 2020</small>
						</p>
					</div>
					<share-buttons
						v-if="routeContext.pathname === '/'"
						glyphs
						no-querystring
						:share-thumbnail="assetUrl(pinterestThumbnail)"
						:event-data="{ tag: 'homepage' }"
						share-title="ReadWorks">
					</share-buttons>
				</div>
				<awards-list v-if="showAwards"></awards-list>
			</div>
		</footer>
		<!-- end .bottom -->
		<snap-to-top></snap-to-top>
		<div
			id="modal-forgot-password"
			class="modal"
			data-modal-window>
			<div class="modal-container">
				<div class="modal-window">
					<div class="modal-window-wrap">
						<button
							class="modal-close"
							data-modal-close>
							<span aria-hidden="true">&times;</span><span class="hidden-visually"> Close</span>
						</button>
						<section class="modal-content">
							<header class="modal-content-header">
								<h2>Forgot Password</h2>
							</header>
							<div class="modal-content-main -form">
								<form-submitter
									:submit-to="resetPassword"
									form-name="resetPasswordForm"
									:form-data.sync="resetPasswordForm"
									class="form"
									novalidate>
									<auto-form-row
										type="email"
										:data.sync="resetPasswordForm.email"
										class="label-hidden-visually"
										placeholder="Email"
										required>
									</auto-form-row>
									<auto-form-row
										row-class="-full-width"
										:all-valid="resetPasswordForm.allValid"
										type="submit">
										Reset Password
									</auto-form-row>
								</form-submitter>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
		<create-class-modal></create-class-modal>
		<add-kids-modal></add-kids-modal>
		<sr-tr-redirect-modal></sr-tr-redirect-modal>
		<modal
			id="printing-modal"
			centered>
			<template slot="content"> Generating PDF... </template>
		</modal>
		<modal
			id="downtime-modal"
			centered>
			<template slot="content">
				We will be working on the site to make it even better. Maintenance will take place Sunday, June 25 from 9pm - 11pm ET.
			</template>
		</modal>
		<modal
			id="logged-out-automatically-modal"
			ref="loggedOutAutomaticallyModal"
			centered
			ok
			no-auto-close>
			<template slot="header-container">
				<h2>Where&rsquo;d you go?</h2>
			</template>
			<p slot="content">Please log in again to continue</p>
		</modal>
		<modal
			id="token-timeout-modal"
			ref="tokenTimeoutModal"
			centered
			ok
			no-auto-close>
			<template slot="header-container">
				<h2>Hi there</h2>
			</template>
			<p slot="content">To ensure a good experience, please log in again to continue.</p>
		</modal>
		<drupal-name-modal ref="drupalNameModal"> </drupal-name-modal>
		<delete-class-modal ref="deleteClassModal"> </delete-class-modal>
		<archive-class-modal ref="archiveClassModal"> </archive-class-modal>
		<teacher-authentication :route-context="routeContext"> </teacher-authentication>
		<bifurcated-login-modal :route-context="routeContext"></bifurcated-login-modal>
		<video-modal></video-modal>
		<vocabulary-image-modal></vocabulary-image-modal>
		<google-classroom-import-modal></google-classroom-import-modal>
		<modal
			id="no-internet-connection"
			no-auto-close>
			<template slot="content">
				<h2>Thanks for using ReadWorks!</h2>
				<p>If you are seeing this message, the internet connection is slow at the moment, or there is no internet connection at this time.</p>
				<p>Please check your connection.</p>
				<p>Thank you!</p>
				<p>The ReadWorks Team</p>
				<template v-if="userContext && userContext.classCode && numberOfOfflineAssignments">
					<button
						class="button"
						@click="onEnableOfflineModeClick">
						Enable Offline Mode
					</button>
				</template>
			</template>
		</modal>
		<modal id="teacher-message">
			<template slot="header-container">
				<h2 v-html="teacherMessageSubject"></h2>
			</template>
			<div
				slot="content"
				class="text-centered">
				<p v-html="teacherMessageBody"></p>
				<button
					class="button -centered"
					@click="closeModals">
					OK
				</button>
			</div>
		</modal>
		<modal id="student-message">
			<template slot="header-container">
				<h2 v-html="studentMessageSubject"></h2>
			</template>
			<div
				slot="content"
				class="text-centered">
				<p v-html="studentMessageBody"></p>
				<button
					class="button -centered"
					@click="closeModals">
					OK
				</button>
			</div>
		</modal>
		<modal id="class-locked-error">
			<template slot="header-container">
				<h2>Class is Locked</h2>
			</template>
			<div
				slot="content"
				class="archive-class-modal-body text-centered">
				<p>Tell your teacher to unlock this class so you can join.</p>
				<button
					class="button -centered"
					@click="closeModals">
					OK
				</button>
			</div>
		</modal>
		<modal
			id="server-down"
			no-auto-close>
			<template slot="content">
				<h2>Thank you for using ReadWorks!</h2>
				<p>We are working on the site at the moment to make it even better. So please come back in about 30 minutes.</p>
				<p>Thank you for your patience while we do this maintenance.</p>
				<p>The ReadWorks Team</p>
			</template>
		</modal>
		<modal id="help">
			<template slot="content">
				<p>Please describe in detail what you need help with and send it in an email to <a href="mailto:help@readworks.org">help@readworks.org</a>.</p>
			</template>
		</modal>
		<journey-dialog></journey-dialog>
		<donation-parent-modal> </donation-parent-modal>
		<workspace-preview-modal></workspace-preview-modal>
		<offline-assignment-submitted-modal></offline-assignment-submitted-modal>
	</div>
</template>
